import { gql } from '../__generated__';

gql(`
  fragment GuidePriceModelItem on GuidePriceModel {
    id
    price
    pendingPriceChange {
      id
      timeOfChange
      newPrice
    }
  }
`);

export let GET_PRICE = gql(`
  query GetPrice {
    pdf: getPdfPrice {
      ...GuidePriceModelItem
    }
  }
`);

export const UPDATE_PRICE = gql(`
  mutation ChangePdfPrice($input: ChangePdfPriceInput!) {
    changePdfPrice(input: $input) {
      ...GuidePriceModelItem
    }
  }
`);

export const CANCEL_PRICE_UPDATE = gql(`
  mutation CancelPdfPriceChange {
    cancelPdfPriceChange {
      ...GuidePriceModelItem
    }
  }
`);

gql(`
  fragment SingleDocumentAccessModelItem on SingleDocumentAccessQueryModel {
    id
    docId
    docName
    title
    validFrom
    validTo
    userId
    changeModelDocIds
    orderNumber
    guideVersionPublicId
    versionId
  }
`);

export const GET_ACCESSES = gql(`
  query GetAccesses($licenseId: Int!) {
    accesses: singleDocumentAccess(licenseId: $licenseId) {
      ...SingleDocumentAccessModelItem
    }
  }
`);

export const GET_ACCESSES_FOR_USER = gql(`
  query GetAccessesForUser($userId: Int!) {
    accesses: singleDocumentAccessForUser(userId: $userId) {
      ...SingleDocumentAccessModelItem
    }
  }
`);

export const STOP_ACCESSES = gql(`
  mutation StopAccesses($input: StopSingleDocumentAccessInput!) {
    access: stopSingleDocumentAccess(input: $input) {
      ...SingleDocumentAccessModelItem
    }
  }
`);
